export default {
  AUTO_PLAY: 'autoplay',
  CONTROLS: 'controls',
  LOOP: 'loop',
  MUTED: 'muted',
  MUTED_YOUTUBE: 'mute',
  AUTO_HIDE: 'autohide',
  REL: 'rel',
};
